module.exports = __webpack_public_path__ + "img/1486873615.dd42df2a.jpg";